const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000"; // Fallback for local dev

export default API_URL;
